<template>
  <v-dialog v-model="dialog" max-width="600" @click:outside="cancel">
    <v-card flat>
      <v-card-title class="background">
        Give feedback
        <v-spacer></v-spacer>
        <v-btn icon @click="cancel">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-form ref="form" v-model="valid">
        <v-card-text>
          <v-textarea
            flat
            solo
            v-model="answer.feedback"
            label="Write your feedback here"
            :rules="[$rules.required]"
            rows="10"
            :disabled="disabled"
          >
          </v-textarea>
        </v-card-text>
        <template v-if="!disabled">
          <v-divider></v-divider>
          <v-card-text class="py-2">
            <v-row dense>
              <v-spacer></v-spacer>
              <v-col cols="auto">
                <v-btn color="performance" :loading="saving" @click="save">
                  <v-icon class="mr-2">message</v-icon>
                  Save
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </template>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "EditAnnualReviewQuestionFeedbackDialog",
  components: {},
  props: {},
  data: () => ({
    dialog: false,
    valid: false,
    saving: false,
    answer: {},
    disabled: false
  }),
  watch: {},
  computed: {},
  methods: {
    cancel() {
      this.dialog = false;
      this.$emit("cancel");
    },
    save() {
      this.$emit("save", this.answer);
      this.dialog = false;
    },
    showDialog(answer, disabled) {
      this.dialog = true;
      this.answer = Object.assign({}, answer);
      this.disabled = disabled;
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    }
  }
};
</script>
